import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';
import { LubricatedEyeNamePipe } from 'src/app/pipes/lubricated-eye-name.pipe';
import { EyeLubricationInstructions } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';

@Component({
    selector: 'app-eye-lubrication-item',
    templateUrl: './eye-lubrication-item.component.html',
    styleUrl: './eye-lubrication-item.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent, LubricatedEyeNamePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeLubricationItemComponent implements SheetItemComponentBase {

	row!: Row;
	instructions!: EyeLubricationInstructions;
	@Input() startLabel!: string;
	@Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as EyeLubricationInstructions;
	}

	constructor() {
	}
}